import {LoadingOutlined} from "@ant-design/icons";
import React from "react";

const CircularProgress = ({className}: { className?: string }) => {
    return (
        <div className={`loader ${className}`}>
            <LoadingOutlined style={{fontSize: 40}}/>
        </div>
    );
}
export default CircularProgress;